.broadcast-stats {
    display: block;
    max-width: 100%;
    overflow-y: auto;
    height: 100%;
    position: relative;
    border-radius: 3px;
}
